// This object shows a html iFrame popup inside a game
// It puts the game into a standby mode, and shows the popup over the game
// A button at the bottom closes the iFrame and resumes the game

htmlViewer = {};
htmlViewer.BORDER = 20;
htmlViewer.BUTTON_BAR_HEIGHT = 70;

htmlViewer.show = function (
  toLoad,
  closeButtonTranslationPhrase,
  isDataLocalString,
  placeholderData,
  backgroundColor
) {
  if (checkForUndefined(htmlViewer.container)) {
    console.error("htmlViewer has not been created in layout");
    return;
  }

  if (htmlViewer.container.visible) {
    console.erorr("htmlViewer already showing");
    return;
  }

  htmlViewer.translationPhrase = closeButtonTranslationPhrase;
  if (checkForUndefined(htmlViewer.translationPhrase)) {
    htmlViewer.translationPhrase = systemData.isMobile
      ? "t_PressToContinue"
      : "t_clickToContinue";
  }

  htmlViewer.buttonText.text = gdk.translateText(
    htmlViewer.translationPhrase,
    []
  );
  htmlViewer.clock.alpha = 1.0;

  htmlViewer.container.visible = true;
  htmlViewer.container.interactive = true;
  htmlViewer.container.mousedown = htmlViewer.container.touchstart =
    htmlViewer.onClose;

  // Put game to sleep

  // Create div
  htmlViewer.divNode = document.createElement("div");
  htmlViewer.divNode.style.position = "fixed";
  htmlViewer.divNode.style.top = "0px";
  htmlViewer.divNode.style.bottom = "100px";
  htmlViewer.divNode.style.left = "0px";
  htmlViewer.divNode.style.right = "100px";
  htmlViewer.divNode.style.zIndex = "2";

  // Create iFrame inside div
  htmlViewer.iFrameNode = document.createElement("iframe");
  htmlViewer.iFrameNode.style.position = "fixed";
  htmlViewer.iFrameNode.style.width = "100%";
  htmlViewer.iFrameNode.style.height = "100%";
  htmlViewer.iFrameNode.style.left = "0px";

  htmlViewer.iFrameNode.style.background =
    backgroundColor !== undefined ? backgroundColor : "#ffffff";

  htmlViewer.iFrameNode.style.zIndex = "3";

  function processHTMLPage(pageData) {
    if (placeholderData !== undefined) {
      const dataKeys = Object.keys(placeholderData);
      for (let i = 0; i < dataKeys.length; ++i) {
        const key = dataKeys[i];
        const value = placeholderData[key];
        while (pageData.indexOf(key) !== -1) {
          pageData = pageData.replace(key, value);
        }
      }
    }
    htmlViewer.iFrameNode.setAttribute("srcdoc", pageData);
  }

  if (isDataLocalString) {
    processHTMLPage(toLoad);
  } else {
    let pageRequest = new XMLHttpRequest();
    pageRequest.onreadystatechange = function () {
      if (pageRequest.readyState === 4 && pageRequest.status === 200) {
        processHTMLPage(pageRequest.response);
      }
    };
    pageRequest.open("GET", toLoad, true);
    pageRequest.send();
  }

  htmlViewer.divNode.appendChild(htmlViewer.iFrameNode);
  document.body.appendChild(htmlViewer.divNode);

  if (gdk.deviceInfo.mobile) {
    // Apple doesnt play nice with scrolling / size, so we need to tell it how to behave
    htmlViewer.divNode.style.scrolling = "no";
    htmlViewer.iFrameNode.style.scrolling = "no";
    htmlViewer.divNode.style.webkitOverflowScrolling = "touch";
    htmlViewer.iFrameNode.style.webkitOverflowScrolling = "touch";
    htmlViewer.divNode.style.overflowY = "scroll";
    htmlViewer.iFrameNode.style.overflowY = "scroll";
  }

  // Redraw graphics
  htmlViewer.onResize();
};

htmlViewer.onResize = function () {
  if (
    checkForUndefined(htmlViewer.container) ||
    !htmlViewer.container.visible
  ) {
    return;
  }
  let platformData = gdk.getPlatformScreenData();
  let topOffset = platformData.screenData.borderTop;
  let borderWidth = htmlViewer.BORDER * 2;
  var width = systemData.PHYSICAL_SCREEN_WIDTH - borderWidth * 2;
  var height =
    systemData.PHYSICAL_SCREEN_HEIGHT - (topOffset + htmlViewer.BORDER * 3);

  // Redraw graphics
  htmlViewer.container.clear();
  htmlViewer.container.beginFill(0x000000, 0.7);
  htmlViewer.container.drawRect(
    0,
    0,
    systemData.PHYSICAL_SCREEN_WIDTH,
    systemData.PHYSICAL_SCREEN_HEIGHT
  );
  htmlViewer.container.endFill();

  htmlViewer.container.lineStyle(3, 0x555555, 1);
  htmlViewer.container.beginFill(0, 1);
  htmlViewer.container.drawRect(
    htmlViewer.BORDER * 2,
    systemData.PHYSICAL_SCREEN_HEIGHT - htmlViewer.BUTTON_BAR_HEIGHT,
    width,
    htmlViewer.BUTTON_BAR_HEIGHT - htmlViewer.BORDER
  );
  htmlViewer.container.endFill();

  // Separate the width into two separate dynamic regions for the two elements (button text and clock),
  // with the button text taking the biggest share
  // In this way the scales and the positions of the two elements can be recalculated in a way that neither of them overlaps with the other.
  const buttonTextRegionWidth = width * 0.85;
  const clockRegionWidth = width - buttonTextRegionWidth;

  // debug rects - comment in to see the region for the clock and the button text
  /*
	console.log("width: " + width + " buttonTextRegionWidth: " + buttonTextRegionWidth + " clockRegionWidth: " + clockRegionWidth);
	// clock region
	htmlViewer.container.lineStyle(2, 0x555555, 1);
	htmlViewer.container.beginFill(0xFF0000, 0.8);
	htmlViewer.container.drawRect(borderWidth, systemData.PHYSICAL_SCREEN_HEIGHT - htmlViewer.BUTTON_BAR_HEIGHT, clockRegionWidth, htmlViewer.BUTTON_BAR_HEIGHT - htmlViewer.BORDER);
	htmlViewer.container.endFill();
	
	// clock region centre
	htmlViewer.container.lineStyle(2, 0x555555, 1);
	htmlViewer.container.beginFill(0x0000FF, 1);
	htmlViewer.container.drawCircle(borderWidth + clockRegionWidth/2, systemData.PHYSICAL_SCREEN_HEIGHT - (htmlViewer.BUTTON_BAR_HEIGHT + htmlViewer.BORDER)/2, 6);
	htmlViewer.container.endFill();

	// button region Region
	htmlViewer.container.lineStyle(2, 0x555555, 1);
	htmlViewer.container.beginFill(0x00FF00, 0.8);
	htmlViewer.container.drawRect(borderWidth + clockRegionWidth, systemData.PHYSICAL_SCREEN_HEIGHT - htmlViewer.BUTTON_BAR_HEIGHT, buttonTextRegionWidth, htmlViewer.BUTTON_BAR_HEIGHT - htmlViewer.BORDER);
	htmlViewer.container.endFill();

	// button region Region centre
	htmlViewer.container.lineStyle(2, 0x555555, 1);
	htmlViewer.container.beginFill(0x0000FF, 1);
	htmlViewer.container.drawCircle(borderWidth + clockRegionWidth + buttonTextRegionWidth/2, systemData.PHYSICAL_SCREEN_HEIGHT - (htmlViewer.BUTTON_BAR_HEIGHT + htmlViewer.BORDER)/2, 6);
	htmlViewer.container.endFill();
	*/

  let buttonTextX = borderWidth + clockRegionWidth + buttonTextRegionWidth / 2;
  let buttonTextY =
    systemData.PHYSICAL_SCREEN_HEIGHT -
    (htmlViewer.BUTTON_BAR_HEIGHT + htmlViewer.BORDER) / 2;
  htmlViewer.buttonText.position.set(buttonTextX, buttonTextY);
  htmlViewer.buttonText.scale.set(1);

  // deflate the region a bit, so that the button text scales down before touching the clock text
  let availableWidthToFill = buttonTextRegionWidth - borderWidth / 2;
  if (htmlViewer.buttonText.width > availableWidthToFill) {
    var scale = availableWidthToFill / htmlViewer.buttonText.width;
    htmlViewer.buttonText.width = availableWidthToFill;
    htmlViewer.buttonText.height *= scale;
  }

  // visual vertical divider of button text and clock
  htmlViewer.container.lineStyle(3, 0x555555, 1);
  htmlViewer.container.moveTo(
    borderWidth + clockRegionWidth,
    systemData.PHYSICAL_SCREEN_HEIGHT - htmlViewer.BUTTON_BAR_HEIGHT
  );
  htmlViewer.container.lineTo(
    borderWidth + clockRegionWidth,
    systemData.PHYSICAL_SCREEN_HEIGHT - htmlViewer.BORDER
  );

  let clockX = borderWidth + clockRegionWidth / 2;
  let clockY =
    systemData.PHYSICAL_SCREEN_HEIGHT -
    (htmlViewer.BUTTON_BAR_HEIGHT + htmlViewer.BORDER) / 2;
  htmlViewer.clock.timeText.position.set(clockX, clockY);
  htmlViewer.clock.timeText.scale.set(1.0);

  // deflate the clock region a bit too, so that the clock text resizes before it touches the border and the button text
  availableWidthToFill = clockRegionWidth - borderWidth * 0.5;
  if (htmlViewer.clock.timeText.width > availableWidthToFill) {
    var scale = availableWidthToFill / htmlViewer.clock.timeText.width;
    htmlViewer.clock.timeText.scale.set(scale);
  }

  htmlViewer.divNode.style.top = htmlViewer.BORDER + topOffset + "px";
  htmlViewer.divNode.style.left = htmlViewer.BORDER + "px";
  htmlViewer.divNode.style.width = width + "px";
  htmlViewer.divNode.style.height =
    height - htmlViewer.BUTTON_BAR_HEIGHT + "px";

  htmlViewer.iFrameNode.style.top = htmlViewer.BORDER + topOffset + "px";
  htmlViewer.iFrameNode.style.left = borderWidth + "px";
  htmlViewer.iFrameNode.style.width = width + "px";
  htmlViewer.iFrameNode.style.height =
    height - htmlViewer.BUTTON_BAR_HEIGHT + "px";
};

htmlViewer.onClose = function () {
  // Remove iFrame (also need to undefine reference to clean up object)
  htmlViewer.iFrameNode.parentNode.removeChild(htmlViewer.iFrameNode);
  htmlViewer.iFrameNode = undefined;

  htmlViewer.divNode.parentNode.removeChild(htmlViewer.divNode);
  htmlViewer.divNode = undefined;

  htmlViewer.clock.alpha = 0.0;
  // Clear container
  htmlViewer.container.clear();
  htmlViewer.container.interactive = false;
  htmlViewer.container.visible = false;

  // Wake up game
};

htmlViewer.initialise = function (parent) {
  htmlViewer.container = new PIXI.Graphics();
  parent.addChild(htmlViewer.container);

  htmlViewer.container.visible = false;

  htmlViewer.buttonText = new PIXI.Text("TEXT HERE", {
    fontFamily: "Arial",
    fontSize: htmlViewer.BUTTON_BAR_HEIGHT / 2,
    fill: 0xffffff,
    align: "center",
  });
  htmlViewer.buttonText.anchor.set(0.5);
  htmlViewer.container.addChild(htmlViewer.buttonText);

  htmlViewer.clock = standardObjectFactory.createClock();
  htmlViewer.clock.clockFormatString = "HH : MM";
  htmlViewer.clock.timeText = new PIXI.Text("00:00", {
    fontFamily: "Arial",
    fontSize: (htmlViewer.BUTTON_BAR_HEIGHT / 2) * 0.7,
    fill: 0xffffff,
    align: "center",
  });
  htmlViewer.clock.timeText.setTextBase = htmlViewer.clock.timeText.setText;

  htmlViewer.clock.timeText.setText = function (text) {
    //console.log(text + " clock tick");
    let updateSizes = text !== htmlViewer.clock.timeText.text;

    let txtWidth = htmlViewer.clock.timeText.width;
    htmlViewer.clock.timeText.setTextBase(text);
    let txtNewWidth = htmlViewer.clock.timeText.width;
    if (updateSizes) {
      htmlViewer.onResize();
    }
  };

  htmlViewer.clock.addChild(htmlViewer.clock.timeText);
  htmlViewer.clock.timeText.anchor.set(0.5);
  htmlViewer.clock.visible = standardObjectFactory.canShowClock();
  htmlViewer.clock.alpha = 0;
  htmlViewer.container.addChild(htmlViewer.clock);
};

htmlViewer.getFilesRequired = function () {
  return [];
};

Reflex.registerEventHandler("resize", htmlViewer.onResize);
